import UserEditor from './user-editor';

export default UserEditor;